/** Record id standing in for a record that does not exist yet. */
export const MAKE_NEW_RECORD = 'MAKE_NEW_RECORD_ID'
